// extracted by mini-css-extract-plugin
export default {"mainContent":"styles_mainContent__2D6fM","formConteiner":"styles_formConteiner__a2UDs","formWrapper":"styles_formWrapper__YCUav","languageSwitcher":"styles_languageSwitcher__VP06C"};